import { render, staticRenderFns } from "./phoneUnbound.vue?vue&type=template&id=01158bef&scoped=true"
import script from "./phoneUnbound.vue?vue&type=script&lang=js"
export * from "./phoneUnbound.vue?vue&type=script&lang=js"
import style0 from "./phoneUnbound.vue?vue&type=style&index=0&id=01158bef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01158bef",
  null
  
)

export default component.exports